import styled from "styled-components";
import { grey, green } from "@material-ui/core/colors";
import { TableRow, TableCell, Checkbox } from "@material-ui/core";

export const STHeaderTableRow = styled(TableRow)`
  && {
    height: 30px;
  }
`;

export const STBodyTableRow = styled(TableRow)`
  && {
    height: 33px;
  }
`;

export const STHeaderTableCell = styled(TableCell)`
  && {
    color: #000000;
    background: ${grey[300]};
    border: 1px solid ${grey[400]};
    font-size: 14px;
    font-weight: bold;
    padding: 0;
  }
`;

export const STBodyTableCell = styled(TableCell)`
  && {
    color: #000000;
    border: 1px solid ${grey[400]};
    font-size: 14px;
  }
`;

export const STEmptyDataTableCell = styled(TableCell)`
  && {
    text-align: center;
    padding-top: 16px;
  }
`;

export const STReviewCheckbox = styled(Checkbox)`
  && {
    color: ${green[400]};
    padding: 0;
    cursor: none;
  }
`;

export const STSelectCheckbox = styled(Checkbox)`
  && {
    padding: 0;
  }
`;

export const STReviewByText = styled.div`
  padding-left: 8px;
`;

